function createConstants(...constants) {
    return constants.reduce((acc, constant) => {
        acc[constant] = constant;
        return acc;
    }, {});
}

export default createConstants(
    'RECEIPTS_REQUEST',
    'RECEIPTS_REQUEST_FAILED',
    'RECEIPTS_REQUEST_SUCCESS',
    'RECEIVE_RECEIPTS',
    'RECEIPT_FROM_FILTER_CHANGE',
    'RECEIPT_TO_FILTER_CHANGE',
    'RECEIPT_FILTER_TYPE_CHANGE',
    'RECEIPT_FILTER_USER_CHANGE',
    'SELECTED_RECEIPTS_CHANGE',
    'RECEIPT_FILTER_BRANCH_CHANGE'
);
